import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle"> Viewpoints:</div>
                                            <p>These questions stimulate consideration of multiple
                                                viewpoints and test your thinking about the perceptions and
                                                involvement of stakeholders. They are not meant to be about
                                                how to present something to different audiences, but a
                                                genuine 'eye opener' in terms of how other groups might see
                                                things. Viewpoint questions force you to take a different
                                                stance and thus open up possibilities. Examples might
                                                include: </p>
                                            <ul className="greenbullet-list">
                                                <li>How would this issue/opportunity look to our
                                                    employees/shareholders/families/communities/neighbours/competitors/customers?
                                                </li>
                                                <li>How would an expert frame this issue; what different
                                                    questions would they ask?
                                                </li>
                                                <li>How would an enemy see this issue; how would an ally see
                                                    it?
                                                </li>
                                            </ul>
                                            <p className="para-first-pad"><span
                                                className="subtiltereg">Summary:</span> These questions are
                                                all about expanding your thinking to see things from as many
                                                angles as possible. It is especially important at this stage
                                                to think about who the stakeholders and customers are and
                                                how they would view the situation. This will help later on
                                                in the process when
                                                trying to gain buy-in to your idea(s). </p>
                                            <div className="border_subtitle">Problems:</div>
                                            <p>As well as helping to anticipate pitfalls or barriers to
                                                success, these questions are about visualising the future
                                                and testing your thinking by asking 'what if?' It is
                                                important that they are not used in a 'yes...but' way; they
                                                should be used to test ideas rather than to stiﬂe them. So,
                                                as well as testing the robustness of your ideas or
                                                solutions, they help to make sure that you have
                                                considered a range of eventualities. Examples might
                                                include: </p>
                                            <ul className="greenbullet-list">
                                                <li>What could stop this from working? What could go
                                                    wrong?
                                                </li>
                                                <li>What if (X) changed, how would that affect things?</li>
                                                <li>How will we overcome any obstacles we anticipate?</li>
                                            </ul>
                                            <p className="para-first-pad"><span
                                                className="subtiltereg">Summary:</span> Your replies should
                                                help formulate potential ideas and solutions. Try to remain
                                                as open as possible to give full consideration to the ideas
                                                being discussed. </p>
                                            <div className="border_subtitle">Checks:</div>
                                            <p>These questions are the only truly operational questions on
                                                the list; however, they are not meant to be about
                                                monitoring, but about visualising a course of events to see
                                                how success will be achieved. </p>
                                            <p>Fundamentally they are about creating a clear picture of
                                                success and they also set up the possibility of continuous
                                                innovation, making you consider progress stages and build in
                                                responsiveness and realignment. Examples might include: </p>
                                            <ul className="greenbullet-list">
                                                <li>How will we know if we are succeeding; what will tell us
                                                    that things are better?
                                                </li>
                                                <li>What will success look like; what are our success
                                                    criteria?
                                                </li>
                                                <li>What will be the signs that we should stop and try
                                                    something else?
                                                </li>
                                            </ul>
                                            <p className="para-first-pad"><span
                                                className="subtiltereg">Summary:</span> These questions help
                                                you to future plan and to map out what success looks like.
                                                Give this section enough time to ensure that the concept you
                                                have considered meets your original
                                                purpose and you have a strategy to make it a success. </p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}